export const COMMON_CATEGORIES = {
	TV: 'tv',
	ALPATVAR: 'alpatvar',
};
